export default {
  section: {
    marginBottom: 72
  },
  sectionHeader: {
    display: 'flex',
    alignItems: 'center'
  },
  sectionTitle: {
    margin: [[16, 20, 23, 0]]
  }
}
